import merchantGatewayApi from 'apis/merchant-gateway/api';

import {
  OrderApiCredentials,
  OrderApiCredentialsResponse,
  OrderApiKeyResponse,
  OrderApiStatusSubscriptionPayload,
  OrderApiWebhookRegistrationPayload,
  OrderApiWebhookData,
} from './types';

const BaseEndpoint = '/pos-integration-service/order/access/merchant';

export const fetchOrderApiCredentials = (merchantId: string): Promise<OrderApiCredentials[]> =>
  merchantGatewayApi
    .get<OrderApiCredentialsResponse>(`${BaseEndpoint}/${merchantId}/credentials`)
    .then(response => response.data);

export const createOrderApiCredentials = (merchantId: string): Promise<OrderApiCredentials> =>
  merchantGatewayApi
    .post<OrderApiCredentials>(`${BaseEndpoint}/${merchantId}/credentials`)
    .then(response => response.data);

export const putVenueInOrderApiCredentials = (
  merchantId: string,
  credentialId: string,
  venueId: string,
): Promise<boolean> =>
  merchantGatewayApi
    .put<boolean>(`${BaseEndpoint}/${merchantId}/credentials/${credentialId}/venues/${venueId}`)
    .then(() => true);

export const removeVenueInOrderApiCredentials = (
  merchantId: string,
  credentialId: string,
  venueId: string,
): Promise<boolean> =>
  merchantGatewayApi
    .delete<boolean>(`${BaseEndpoint}/${merchantId}/credentials/${credentialId}/venues/${venueId}`)
    .then(() => true);

export const createOrderApiApiKey = (merchantId: string, credentialId: string): Promise<OrderApiKeyResponse> =>
  merchantGatewayApi
    .post<OrderApiKeyResponse>(`${BaseEndpoint}/${merchantId}/credentials/${credentialId}/keys`)
    .then(response => response.data);

export const resetOrderApiApiKey = (
  merchantId: string,
  credentialId: string,
  apiKeyId: string,
): Promise<OrderApiKeyResponse> =>
  merchantGatewayApi
    .patch<OrderApiKeyResponse>(`${BaseEndpoint}/${merchantId}/credentials/${credentialId}/keys/${apiKeyId}`)
    .then(response => response.data);

export const fetchOrderApiWebhook = (merchantId: string, credentialId: string): Promise<OrderApiWebhookData> =>
  merchantGatewayApi
    .get<OrderApiWebhookData>(`${BaseEndpoint}/${merchantId}/credentials/${credentialId}/webhook`)
    .then(response => response.data);

export const registerOrderApiWebhook = (
  merchantId: string,
  credentialId: string,
  data: OrderApiWebhookRegistrationPayload,
): Promise<boolean> =>
  merchantGatewayApi
    .post<boolean>(`${BaseEndpoint}/${merchantId}/credentials/${credentialId}/webhook/register`, data)
    .then(() => true);

export const updateOrderApiWebhook = (
  merchantId: string,
  credentialId: string,
  webhookId: string,
  data: OrderApiWebhookRegistrationPayload,
): Promise<boolean> =>
  merchantGatewayApi
    .put<boolean>(`${BaseEndpoint}/${merchantId}/credentials/${credentialId}/webhook/${webhookId}`, data)
    .then(() => true);

export const subscribeToStatusInOrderApiCredentials = (
  merchantId: string,
  credentialId: string,
  data: OrderApiStatusSubscriptionPayload,
): Promise<boolean> =>
  merchantGatewayApi
    .put<boolean>(`${BaseEndpoint}/${merchantId}/credentials/${credentialId}/webhook/status`, data)
    .then(() => true);

export const unSubscribeToStatusInOrderApiCredentials = (
  merchantId: string,
  credentialId: string,
  data: OrderApiStatusSubscriptionPayload,
): Promise<boolean> =>
  merchantGatewayApi
    .post<boolean>(`${BaseEndpoint}/${merchantId}/credentials/${credentialId}/webhook/status/unsubscribe`, data)
    .then(() => true);
